import {
  getCurrentProfileSelect,
  PROFILE_KEY
} from '@gymaholic/packages'
import BackgroundImage from 'components/BackgroundImage.js'
import Button from 'components/Button'
// import { LoadingIcon } from 'components/Icon/icons/loading'
import { ProfileEditIcon } from 'components/Icon/icons/profile-edit'
import { PageLoader } from 'components/Page/Page.Loader'
import Text from 'components/Text'
import { View } from 'components/View'
import { BRAND_IMAGE } from 'constants/brand.js'
import getIdReduxUtil from 'modules/redux/utils/get-id'
import getValueReduxUtil from 'modules/redux/utils/get-value'
import isLoadingReduxUtil from 'modules/redux/utils/is-loading'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import { loadStartedPlansAction } from 'modules/plan/redux/actions'
import {
  getStartedPlansSelector,
  isStartedPlansLoadedSelector
} from 'modules/plan/redux/selectors'
import { getProfileByNameSelector } from 'modules/profile/redux/selectors'
// import StartedPlansList from 'pages/Creator/CustomerProfile/StartedPlans'
import { WeightGraph } from 'pages/Creator/CustomerProfile/WeightGraph'
import { WorkoutsLoggedGraph } from 'pages/Creator/CustomerProfile/WorkoutsLoggedGraph'
import React from 'react'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import pushRouterAction from 'modules/router/actions/push'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import loadByNameProfileAction from 'modules/profile/redux/actions/load-by-name'
import SuggestedPlan from 'pages/Creator/CustomerProfile/SuggestedPlan/index.js'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

import { StartedPlan } from 'pages/Creator/CustomerProfile/StartedPlan/index.js'
import { InstallAppForBetterWorkoutExperience } from 'components/InstallApp/index.js'
import { isInterestedInWorkoutsProfileSelect } from 'modules/profile/redux/selectors/getInterestFocus/index.js'
import { isAndroidDownloadModalOpenSelect } from 'modules/modal/selectors/is-android-download-modal-open'

const ANALYTIC_EVENT = {
  EDIT_PROFILE: 'EDIT_PROFILE',
  UPDATE_WEIGHT: 'UPDATE_WEIGHT',
  SEE_WORKOUTS: 'SEE_WORKOUTS',
  STARTED_PLAN: 'STARTED_PLAN'
}

export default function CustomerProfile (props) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const dispatch = useDispatch()

  const customerProfile = useSelector(getProfileByNameSelector(props.match.params.name))
  const currentProfile = useSelector(getCurrentProfileSelect)
  const profile = customerProfile || currentProfile
  const startedPlans = useSelector(getStartedPlansSelector())
  const name = getValueReduxUtil(
    profile,
    PROFILE_KEY.NAME
  )
  const media = getValueReduxUtil(
    profile,
    PROFILE_KEY.MEDIA
  )
  const isInterestedInWorkouts = useSelector(isInterestedInWorkoutsProfileSelect)
  // Hide graphs when Android download modal is open - certainly a z-index issue
  const isAndroidDownloadModalOpen = useSelector(isAndroidDownloadModalOpenSelect)

  // const [selectedPlanIndex, setSelectedPlanIndex] = React.useState(0)
  // const isTrainingPlansLoading = useSelector(isStartedPlansLoadingSelector())
  const customerProfileIsCurrentProfile = (
    getIdReduxUtil(customerProfile) === getIdReduxUtil(currentProfile) ||
    props.isAccountPage
  )
  const isStartedPlansLoaded = useSelector(isStartedPlansLoadedSelector())
  // const [onboardingStep, setOnboardingStep] = React.useState(null)
  // const [onboardingStepUpdated, setOnboardingStepUpdated] = React.useState(false)
  // const walkThroughIndex = getValueReduxUtil(profile, PROFILE_KEY.WALK_THROUGH_INDEX)

  React.useEffect(() => {
    if (profile) {
      loadProfile()
      loadStartedPlans()
    }
  }, [profile])

  // React.useEffect(() => {
  //   if ((walkThroughIndex || walkThroughIndex === null) && !onboardingStep && !onboardingStepUpdated) {
  //     setOnboardingStep(walkThroughIndex)
  //     setOnboardingStepUpdated(true)
  //   }
  // }, [walkThroughIndex])

  const loadStartedPlans = () => {
    if (startedPlans) {
      return
    }

    if (isStartedPlansLoaded) {
      return
    }

    dispatch(loadStartedPlansAction(getIdReduxUtil(profile)))
  }

  const loadProfile = () => {
    if (profile && media) {
      return
    }

    dispatch(loadByNameProfileAction(name))
  }

  if (
    profile === undefined ||
    isLoadingReduxUtil(profile)
  ) {
    return <PageLoader />
  }

  const handlePressEdit = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.EDIT_PROFILE)
    dispatch(
      pushRouterAction({
        pathname: interpolateRouteUtil(
          ROUTE_PATH.ACCOUNT_EDIT,
          { name }
        )
      })
    )
  }

  const handlePressWeight = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.UPDATE_WEIGHT)
    dispatch(
      pushRouterAction({
        pathname: interpolateRouteUtil(
          ROUTE_PATH.ACCOUNT_EDIT,
          { name }
        ),
        state: { openWeightModal: true }
      })
    )
  }

  const handleClickTryWorkout = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.SEE_WORKOUTS)

    dispatch(
      pushRouterAction({
        pathname: ROUTE_PATH.WORKOUTS
      })
    )
  }

  // const handleClickPlan = (index) => {
  //   logEventAnalyticsUtil(
  //     getActionStrReduxUtil(
  //       ANALYTIC_EVENT.STARTED_PLAN,
  //       getNamePlanUtil(startedPlans[index])
  //     )
  //   )
  //
  //   setSelectedPlanIndex(index)
  // }

  // const renderStartedPlans = () => {
  //   if (isTrainingPlansLoading) {
  //     return (
  //       <View
  //         centered
  //         bgc='white'
  //       >
  //         <LoadingIcon
  //           stroke='black'
  //           style={{
  //             width: '30px',
  //             height: '30px'
  //           }}
  //         />
  //       </View>
  //     )
  //   }
  //
  //   if (!startedPlans) {
  //     return
  //   }
  //
  //   return (
  //     <StartedPlansList
  //       items={startedPlans}
  //       handleClickPlan={handleClickPlan}
  //       selectedPlanIndex={selectedPlanIndex}
  //       listItemStyle={{ paddingLeft: '19px' }}
  //       showOpenButton
  //     />
  //   )
  // }

  // if (role && role === PROFILE_ROLE.CREATOR) {
  //   if ((onboardingStep === null || onboardingStep === 0) && props.isAccountPage) {
  //     return (
  //       <OnboardingProfile {...props} onSubmit={() => setOnboardingStep(onboardingStep + 1)} />
  //     )
  //   }
  //
  //   if (onboardingStep === 1 && props.isAccountPage) {
  //     return (
  //       <OnboardingAboutMe {...props} onSubmit={() => setOnboardingStep(onboardingStep + 1)} />
  //     )
  //   }
  //
  //   if (onboardingStep === 2 && props.isAccountPage) {
  //     return (
  //       <OnboardingPlans {...props} onSubmit={() => setOnboardingStep(onboardingStep + 1)} />
  //     )
  //   }
  // }

  return (
    <View
      bgc='white'
      w={isSmallScreen ? 'unset' : '500px'}
      m={isSmallScreen ? 'unset' : '0 auto'}
      pb='100px'
    >
      <View
        pl='16px'
        pr='24px'
        pt='10px'
        row
        style={{
          justifyContent: 'space-between'
        }}
      >
        <View />
        {
          customerProfileIsCurrentProfile &&
          (
            <Button onClick={handlePressEdit}>
              <ProfileEditIcon />
            </Button>
          )
        }
      </View>

      <View
        centered
        mx='32px'
      >
        <View
          w='120px'
          h='120px'
          style={{
            position: 'relative'
          }}
        >
          {
            media?.[0]
              ? (
                <BackgroundImage
                  source={media[0].url}
                  bdr='big'
                />
                )
              : (
                <BackgroundImage
                  source={BRAND_IMAGE}
                  bdr='big'
                  style={{ border: '1px solid black' }}
                />
                )
          }
          {props.children}
        </View>

        <Text
          fs='1.75em'
          mt={2}
          mb
          c='#151D21'
          fw='814'
          ta
        >
          {name}
        </Text>
      </View>
      {/* {renderStartedPlans()} */}

      {
        customerProfileIsCurrentProfile &&
        profile &&
        (
          <>
            <InstallAppForBetterWorkoutExperience />
            <StartedPlan />
            {!!isInterestedInWorkouts && <SuggestedPlan />}
            {/* <Achievements /> */}
            {!isAndroidDownloadModalOpen && (
              <>
                <WeightGraph
                  handlePressWeight={handlePressWeight}
                  handleClickAddWeight={handlePressEdit}
                />
                <WorkoutsLoggedGraph
                  handleClickTryWorkout={handleClickTryWorkout}
                />
              </>
            )}
          </>
        )
      }
    </View>
  )
}
